import * as React from 'react';

import { UitkFigure, UitkImage, UitkFigureAspectRatioType, UitkQueuedImage } from 'uitk-react-images';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { UitkText } from 'uitk-react-text';

import { ImageType } from 'types/shared';
import { OperatedBy } from 'components/search/listings/offer';

interface AirlineProps {
  logo?: ImageType;
  name: string;
  flightOperatedBy?: string;
  queued?: boolean;
}

export const Airline = ({ logo, name, flightOperatedBy, queued }: AirlineProps) => {
  const logoSize = '16px';
  const logoSizing = { height: logoSize, width: logoSize };
  const ImageTag = queued ? UitkQueuedImage : UitkImage;

  return (
    <UitkLayoutFlex alignContent="center" space="one" className="truncate" data-test-id="airline-info">
      {logo && (
        <div
          aria-hidden="true"
          style={logoSizing}
          data-test-id={`airline-logo${queued ? '-queued' : ''}`}
          data-alt={name}
          className="uitk-text-primary-theme uitk-flex-shrink-0"
        >
          <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
            <ImageTag alt={logo.description} src={logo.url} />
          </UitkFigure>
        </div>
      )}
      <UitkText theme="primary" dataTestId="flight-operated">
        {name}
      </UitkText>
      {flightOperatedBy && <OperatedBy flightOperatedBy={flightOperatedBy} />}
    </UitkLayoutFlex>
  );
};
